import { render, staticRenderFns } from "./TotalCost.vue?vue&type=template&id=89f6dc66&scoped=true"
import script from "./TotalCost.vue?vue&type=script&lang=js"
export * from "./TotalCost.vue?vue&type=script&lang=js"
import style0 from "./TotalCost.vue?vue&type=style&index=0&id=89f6dc66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89f6dc66",
  null
  
)

export default component.exports